import { Component, Input } from "@angular/core";

@Component({
  selector: "app-app-store-logos",
  templateUrl: "./app-store-logos.component.html",
  styleUrls: ["./app-store-logos.component.scss"],
})
export class AppStoreLogosComponent {
  @Input() classes: string[] = null;

  constructor() {}
}
